import { CheckboxInput } from './components/Checkbox';

export default CheckboxInput;
